import React, { useEffect, useState } from "react";
import Loading from "../common/Loading";

function ToolSSO() {
  // as we are embedding the Portal in a tool, cookies acceptance is implicit
  localStorage.setItem("cookies-accepted-on", new Date().getTime().toString());

  useEffect(() => {
    // when this page is called, make sure the previous token is removed
    localStorage.setItem("session_token", "");
    const interval = setInterval(() => {
      const token = localStorage.getItem("session_token");
      // check if we have a token set and then redirect to the desired URL
      if (token) {
        const toolTargetURL = localStorage.getItem("tool_target_url");
        if (toolTargetURL) {
          window.location.href = toolTargetURL;
        }
      }
    }, 200);

    return () => clearInterval(interval);
  }, []);

  return <Loading loadingMessage={"Loading. Please wait for a moment."} />;
}

export default ToolSSO;
